import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AccordionAnchorDirective} from './accordion/accordionanchor.directive';
import {AccordionLinkDirective} from './accordion/accordionlink.directive';
import {AccordionDirective} from './accordion/accordion.directive';
import {HttpClientModule} from '@angular/common/http';
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {TitleComponent} from '../layout/admin/title/title.component';
import {CardComponent} from './card/card.component';
import {CardToggleDirective} from './card/card-toggle.directive';
import {ModalBasicComponent} from './modal-basic/modal-basic.component';
import {MessageBoxComponent} from './message-box/message-box.component';
import { DonorAddEditComponent } from './donor-add-edit/donor-add-edit.component';
import { DonorPickerComponent } from './donor-picker/donor-picker.component';
import { SavedReportsComponent } from './saved-reports/saved-reports.component';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { AdvancedReportFilterComponent } from './advanced-report-filter/advanced-report-filter.component';
import { DesignationChooserComponent } from './designation-chooser/designation-chooser.component';
import { DocumentListComponent } from './document-list/document-list.component';
import {GridFooterComponent} from './grid-footer/grid-footer.component';
import {SpinnerComponent} from './spinner/spinner.component';
import {ClickOutsideModule} from 'ng-click-outside';
import { TrimOnBlurModule } from 'ng2-trim-on-blur';
import { NgSelectModule, NgSelectComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { NgxMaskModule, IConfig } from 'ngx-mask'; //needed for textbox mask

export const options: Partial<IConfig> | (() => Partial<IConfig>) = {}; //needed for textbox mask

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    PerfectScrollbarModule,
    ClickOutsideModule,
    AgGridModule.withComponents([]),
    NgxMaskModule.forRoot(options), //needed for textbox mask
    FormsModule,
    NgSelectModule
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    CardToggleDirective,
    HttpClientModule,
    PerfectScrollbarModule,
    TitleComponent,
    CardComponent,
    ModalBasicComponent,
    MessageBoxComponent,
    DonorAddEditComponent,
    DonorPickerComponent,
    SavedReportsComponent,
    DateRangePickerComponent,
    AdvancedReportFilterComponent,
    AgGridModule,
    NgxMaskModule,
    DesignationChooserComponent,
    DocumentListComponent,
    GridFooterComponent,
    SpinnerComponent,
    ClickOutsideModule,
    TrimOnBlurModule,
    NgSelectModule,
    FormsModule
  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    CardToggleDirective,
    TitleComponent,
    CardComponent,
    ModalBasicComponent,
    MessageBoxComponent,
    DonorAddEditComponent,
    DonorPickerComponent,
    SavedReportsComponent,
    DateRangePickerComponent,
    AdvancedReportFilterComponent,
    DesignationChooserComponent,
    DocumentListComponent,
    GridFooterComponent,
    SpinnerComponent
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]
})
export class SharedModule { }
